/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LocationsSearchByRegionQueryVariables = Exact<{
  bottomRightLat: number;
  bottomRightLng: number;
  topLeftLat: number;
  topLeftLng: number;
  sortByLat?: number | null | undefined;
  sortByLng?: number | null | undefined;
}>;

export type LocationsSearchByRegionQuery = {
  readonly restaurantsByRegion: ReadonlyArray<{
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly slug: string;
    readonly address: string;
    readonly city: string;
    readonly state: string;
    readonly zipCode: string;
    readonly isOutpost: boolean;
    readonly phone: string;
    readonly isAcceptingOrders: boolean;
    readonly flexMessage: string | null;
    readonly notAcceptingOrdersReason: string;
    readonly sanitaryGradeDisplayText: string | null;
    readonly sanitaryGradeUrl: string | null;
    readonly showOutpostPriceDifferenciationDisclosure: boolean;
    readonly showDeliveryPriceDifferenciationDisclosure: boolean;
    readonly showWarningDialog: boolean | null;
    readonly warningDialogDescription: string | null;
    readonly warningDialogTimeout: number | null;
    readonly warningDialogTitle: string | null;
    readonly hours: { readonly __typename: 'RestaurantHours'; readonly formatted: string | null };
    readonly asset: { readonly __typename: 'Asset'; readonly url: string };
  }>;
};

export const LocationsSearchByRegionDocument = gql`
  query LocationsSearchByRegion(
    $bottomRightLat: Float!
    $bottomRightLng: Float!
    $topLeftLat: Float!
    $topLeftLng: Float!
    $sortByLat: Float
    $sortByLng: Float
  ) {
    restaurantsByRegion(
      bottomRightLat: $bottomRightLat
      bottomRightLng: $bottomRightLng
      topLeftLat: $topLeftLat
      topLeftLng: $topLeftLng
      sortByLat: $sortByLat
      sortByLng: $sortByLng
    ) {
      __typename
      id
      name
      latitude
      longitude
      slug
      address
      city
      state
      zipCode
      isOutpost
      phone
      isAcceptingOrders
      hours {
        __typename
        formatted
      }
      asset {
        __typename
        url
      }
      flexMessage
      notAcceptingOrdersReason
      sanitaryGradeDisplayText
      sanitaryGradeUrl
      showOutpostPriceDifferenciationDisclosure
      showDeliveryPriceDifferenciationDisclosure
      showWarningDialog
      warningDialogDescription
      warningDialogTimeout
      warningDialogTitle
    }
  }
`;

export function useLocationsSearchByRegionQuery(
  options: Omit<Urql.UseQueryArgs<LocationsSearchByRegionQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LocationsSearchByRegionQuery, LocationsSearchByRegionQueryVariables>({
    query: LocationsSearchByRegionDocument,
    ...options,
  });
}
